import { BodyText, CaptionText, Col, Row, TabPanel } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import React from 'react'

import MultiOnboardingImg from '../../../../img/payment-solutions/ill_multiOnboarding.png'
import MultiAcceptImg from '../../../../img/payment-solutions/ill_multiAccept.png'
import MultiRefundImg from '../../../../img/payment-solutions/ill_multiRefunds.png'
import { saveBannerProgress } from '../../../../utils/session-utils'
import { useApplicationContext } from '../../../../context/ApplicationContext'

export default function MultiParty({ setBannerPage, setProductIntegration }) {
  const { csrf, logger, setCurrentBannerStep } = useApplicationContext()
  return (
    <>
      <TabPanel id="group4-panel4" tabId="group1-panel4">
        <Row className="onboarding-banner-cards-row">
          <Col xs={4}>
            <div
              onClick={() => {
                const sessionObject = {
                  bannerPage: 1,
                  productIntegration: 'mpOnboardSellers',
                }
                saveBannerProgress(csrf, logger, sessionObject)
                setBannerPage(1)
                setCurrentBannerStep(sessionObject)
                setProductIntegration('mpOnboardSellers')
              }}
              className="onboarding-banner-cards"
            >
              <img
                className="onboarding-banner-illustrations"
                src={MultiOnboardingImg}
              />
              <br />
              <BodyText className="onboarding-banner-cards-title">
                <Message id="onboarding-banner.tabFour.productOne" />
              </BodyText>

              <CaptionText className="caption-payment-solutions">
                <Message id="onboarding-banner.tabFour.productOneDesc" />
              </CaptionText>
            </div>
          </Col>
          <Col xs={4}>
            <div
              onClick={() => {
                const sessionObject = {
                  bannerPage: 1,
                  productIntegration: 'mpAcceptPayments',
                }
                saveBannerProgress(csrf, logger, sessionObject)
                setBannerPage(1)
                setCurrentBannerStep(sessionObject)
                setProductIntegration('mpAcceptPayments')
              }}
              className="onboarding-banner-cards"
            >
              <img
                className="onboarding-banner-illustrations"
                src={MultiAcceptImg}
              />
              <br />
              <BodyText className="onboarding-banner-cards-title">
                <Message id="onboarding-banner.tabFour.productTwo" />
              </BodyText>

              <CaptionText className="caption-payment-solutions">
                <Message id="onboarding-banner.tabFour.productTwoDesc" />
              </CaptionText>
            </div>
          </Col>
          <Col xs={4}>
            <div
              onClick={() => {
                const sessionObject = {
                  bannerPage: 1,
                  productIntegration: 'mpIssueRefunds',
                }
                saveBannerProgress(csrf, logger, sessionObject)
                setBannerPage(1)
                setCurrentBannerStep(sessionObject)
                setProductIntegration('mpIssueRefunds')
              }}
              className="onboarding-banner-cards"
            >
              <img
                className="onboarding-banner-illustrations"
                src={MultiRefundImg}
              />
              <br />
              <BodyText className="onboarding-banner-cards-title">
                <Message id="onboarding-banner.tabFour.productThree" />
              </BodyText>

              <CaptionText className="caption-payment-solutions">
                <Message id="onboarding-banner.tabFour.productThreeDesc" />
              </CaptionText>
            </div>
          </Col>
        </Row>
      </TabPanel>
    </>
  )
}
